import { render } from "./TableContent.vue?vue&type=template&id=5553582a&scoped=true"
import script from "./TableContent.vue?vue&type=script&lang=js"
export * from "./TableContent.vue?vue&type=script&lang=js"

import "./TableContent.vue?vue&type=style&index=0&id=5553582a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5553582a"]])

export default __exports__